import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import router from '../router'
import Vue from 'vue'

Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SCF_SENTRY_DSN || '',
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', 'buyer.dripcapital.com', /^\//]
    })
  ],
  ignoreErrors: ['code 401', 'timeout', 'code 422'],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
  environment: process.env.VUE_APP_ENVIRONMENT
  // release: 'portalSCF@' + process.env.VUE_APP_VERSION
})
